export default __webpack_public_path__ + "static/media/gamstop.f2394b45.svg";